import styled from "styled-components";
import { colors } from "../../styles/tokens";

export const Container = styled.div`
  background: ${colors.bg};
  height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
  justify-content: center;
  position: relative;
  overflow: hidden;

  /* Layer 1 — subtle body wash */
  background-image:
    radial-gradient(ellipse 900px 600px at 10% -10%, rgba(10, 63, 214, 0.12) 0%, transparent 60%),
    radial-gradient(ellipse 700px 500px at 90% 110%, rgba(114, 41, 245, 0.10) 0%, transparent 60%);

  /* Layer 2 — brighter hero-level halos with blur */
  &::before {
    content: '';
    position: absolute;
    inset: -10%;
    z-index: 0;
    pointer-events: none;
    background:
      radial-gradient(ellipse 600px 500px at 25% 20%, rgba(114, 41, 245, 0.28) 0%, transparent 55%),
      radial-gradient(ellipse 600px 500px at 80% 80%, rgba(10, 63, 214, 0.28) 0%, transparent 55%),
      radial-gradient(ellipse 400px 300px at 55% 50%, rgba(10, 63, 214, 0.14) 0%, transparent 55%);
    filter: blur(40px);
  }

  > * { position: relative; z-index: 1; }
`;

export const ContainerInputs = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 420px;
  width: 100%;
  padding: 40px 36px;
  background: rgba(255, 255, 255, 0.04);
  backdrop-filter: blur(24px) saturate(160%);
  -webkit-backdrop-filter: blur(24px) saturate(160%);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 20px;
  box-shadow: 0 1px 0 rgba(255,255,255,0.05) inset, 0 30px 60px -20px rgba(0,0,0,0.7);

  @media (max-width: 768px) {
    padding: 28px 22px;
  }

  > div:nth-child(1) {
    margin-bottom: 40px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 8px;

    > img {
      max-width: 180px;
      height: auto;
    }

    &::after {
      content: 'ZONA Admin';
      display: block;
      font-size: 13px;
      color: rgba(255, 255, 255, 0.3);
      font-weight: 400;
      letter-spacing: 0.3px;
    }
  }

  > div:nth-child(2) {
    width: 100%;

    /* Button styling handled by the shared .zona-pill-btn class in styles.css */
    .zona-pill-btn {
      margin: 15px 0 21px 0;
    }
  }

  .container-input {
    margin: 12px 0;

    > input {
      background: #0a0a0a !important;
      border: 1px solid #1a1a1a !important;
      border-radius: 12px !important;
      height: 48px;
      padding: 14px 16px;
      font-size: 16px;
      transition: border-color 0.2s;

      &:focus {
        border-color: rgba(79, 48, 234, 0.4) !important;
      }

      &::placeholder {
        color: rgba(255, 255, 255, 0.3);
      }
    }
  }
`;

export const ErrorMessage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  > span {
    color: #ff4d4f;
    font-size: 13px;
  }
`;

export const ContainerForgotPassword = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;

  > button {
    border: none;
    background: transparent;
    color: ${colors.primary};
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: color 0.15s;

    &:hover {
      color: ${colors.brand};
    }
  }
`;

export const ContainerCreateAccount = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  gap: 10px;

  > a {
    color: rgba(255, 255, 255, 0.5);
    text-decoration: none;
    font-size: 14px;
    width: 100%;
    transition: color 0.15s;

    &:hover {
      color: #fff;
    }
  }
`;

export const LoginWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 100px;
  position: relative;
  z-index: 1;
  max-width: 900px;
  width: 100%;
  padding: 0 32px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 40px;
    padding: 0 20px;
  }
`;

export const PhoneSection = styled.div`
  position: relative;
  flex-shrink: 0;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const FloatingBadge = styled.div`
  position: absolute;
  z-index: 2;
  background: rgba(10, 10, 10, 0.85);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 10px 14px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  font-weight: 600;
  color: #fff;
  white-space: nowrap;
  top: ${p => p.top || 'auto'};
  left: ${p => p.left || 'auto'};
  right: ${p => p.right || 'auto'};
  bottom: ${p => p.bottom || 'auto'};
  animation: floatIn 0.6s ease-out ${p => p.delay || '0s'} both;

  @keyframes floatIn {
    from { opacity: 0; transform: translateY(10px); }
    to { opacity: 1; transform: translateY(0); }
  }
`;

export const PhoneMockup = styled.div`
  width: 280px;
  height: 570px;
  border-radius: 48px;
  border: 8px solid #2a2a2a;
  overflow: hidden;
  position: relative;
  background: #000;
  transform: perspective(800px) rotateY(-15deg) rotateX(-2deg) rotateZ(2deg);
  box-shadow: 20px 30px 60px rgba(0, 0, 0, 0.7),
              0 0 40px rgba(255, 255, 255, 0.06),
              0 0 80px rgba(255, 255, 255, 0.03),
              inset 0 0 0 2px #0a0a0a;

  &::before {
    content: '';
    position: absolute;
    top: 10px;
    left: 50%;
    transform: translateX(-50%);
    width: 90px;
    height: 24px;
    background: #000;
    border-radius: 20px;
    z-index: 3;
  }

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 40px;
    border: 1px solid rgba(255, 255, 255, 0.05);
    z-index: 2;
    pointer-events: none;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 40px;
  }
`;

